var $ = require('jquery');

$(document).ready(function() {
    initColumns();
    initColumn();
    adjustButtons();
    numbers();
})
$(window).on('resize', function() {
    adjustButtons();
})
function initColumns() {
    $('.page-section--main > .wp-block-columns').each(function() {
        var prev = $(this).prev();

        if(prev.length == 0) {
            $(this).addClass('-banner');
        }
    })
}
function initColumn() {
    $('.wp-block-columns .is-style-card').on('click', function() {
        var link = $(this).find('.wp-block-button__link');
        if(link.length != 0) {
            $(link)[0].click();
        }
    })

    // Aria-labels
    $('.wp-block-columns .is-style-card').each(function() {
        var title = $(this).find('.wp-block-heading').text();
        var button = $(this).find('.wp-block-button__link').text();
        var link = $(this).find('.wp-block-button__link');
        var aria = button + ' about ' + title;
        link.attr('aria-label', aria);
    })
}
function adjustButtons() {
    $('.wp-block-columns .is-style-card').each(function() {
        var group = $(this).children('.wp-block-group').last();
        var figure = $(this).children('.wp-block-image').first();

        if(figure.length != 0 ) {
            var height = 'calc(100% - ' + figure.height() + 'px)';
            console.log(height);
            group.css('height', height);
        } else {
            group.css('height', '100%');
        }
    })
}


// - - - NUMBERS - - -

function numbers() {
    // Horizontal Card
    var max = $('.wp-block-columns .is-style-horizontal-card').length;
    $('.wp-block-columns .is-style-horizontal-card').each(function(index) {
        var group = $(this).find('.wp-block-group');
        var position = index + 1;
        var number = (position < 10 ? '0' : '') + position;
        group.prepend('<div class="number ' + numberColorCard(position, max) + '"><span>' + number + '</span></div>');

    })

    // Number Layout
    var max = $('.wp-block-group > .wp-block-columns.is-style-number-layout').length;
    $('.wp-block-group > .wp-block-columns.is-style-number-layout').each(function(index) {
        var image = $(this).find('.wp-block-image');
        var position = index + 1;
        var number = ((index + 1) < 10 ? '0' : '') + (index + 1);
        image.prepend('<div class="number ' + numberColorLayout(position, max) + '"><span>' + number + '</span></div>');
    })
}

// Number Layout
function numberColorLayout(position, max) {
    for (var i = 0; i <= max; i += 4) {
        switch(position) {
            case (1 + i) : return 'yellow'; break;
            case (2 + i) : return 'green'; break;
            case (3 + i) : return 'purple'; break;
            case (4 + i) : return 'pink'; break;
        }
    }
}

// Horizontal Card
function numberColorCard(position, max) {
    for (var i = 0; i <= max; i += 4) {
        switch(position) {
            case (1 + i) : return 'green'; break;
            case (2 + i) : return 'yellow'; break;
            case (3 + i) : return 'pink'; break;
            case (4 + i) : return 'purple'; break;
        }
    }
}
